import React from 'react';

class Slide2 extends React.Component {
    constructor(props) {
        super(props);
        this.slide2 = React.createRef();
        this.handleScroll = this.handleScroll.bind(this);
        this.ctaButtonHandler = this.ctaButtonHandler.bind(this);
        this.state = {
            open: false,
            visible: false,
        };
    }


    componentDidMount() {
        this.props.custScrollTo(this.slide2.current)

        let $slide2Carousel = $('.slide2__carousel');
        $slide2Carousel.filter('.slick-initialized').slick('unslick');
        $slide2Carousel.slick({
            centerMode: true,
            initialSlide: 1,
            slidesToShow: 1,
            infinite: true,
            arrows: true,
            dots: true,
            variableWidth: true,
            nextArrow: "<button class='slick-next slick-arrow' aria-label='Previous' type='button'>Next</button>",
            prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'>Previous</button>",
        });
      
        window.addEventListener('scroll', this.handleScroll);
    }


    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        let view = this.slide2.current.getBoundingClientRect();
        const Buffer = 5
        if (view.top <= Buffer) this.setState({ visible: true });
        if (this.state.visible && (view.top >= window.innerHeight / 2)) {
            this.props.closeSlide();
        }
    }

    getScreenWidth() {
        return window.innerWidth;
    }

    ctaButtonHandler() {
        const nextSlideIsOpen = document.querySelector('.slide-3') != null
        if (nextSlideIsOpen) {
            this.props.custScrollTo(document.querySelector('.slide-3'))
        } else {
            this.props.openNextSlide()
        }
    }

    render() {
        return (
            <div className="container-fluid container-sm slide slide-2" ref={this.slide2}>
                <div className="row justify-content-center">
                    <div className="pres-calc-slide__header col-11 col-sm-12">
                        <h2 className="text-red fw-bold font-size-24 font-size-md-32 font-size-xxl-40 text-center cust-mb-26">{ this.props.data?.slide2.title }</h2>
                        <div className="font-size-16 font-size-md-16 font-size-xxl-18 text-center fw-light text-grey" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.slide2.introText)  }}></div>          
                    </div>
                </div>

                <div className="row justify-content-center d-lg-flex d-none">
                    {this.props.data?.slide2Cards?.map((card, index) => (
                        <div className="col-auto d-flex align-items-center" key={index}>
                            <div className={"slide2__card d-flex flex-column align-items-center" + (card.isDefault ? " slide2__card--default" : "") + (index === 1 ? " slide2__card--lg" : "")}>
                                {card.isDefault && <div className='slide2__card--default-header'>
                                    <div className="w-100 text-center"><p><span>Default option</span> – No action or paperwork {this.getScreenWidth() > 1279 ? "required" : ""}</p></div>
                                </div>
                                }
                                <img src={card.imgSrc} alt={card.imgAlt} className={card.isDefault ? "cust-mt-2" : "cust-mt-4"} />
                                <h6 className="text-center mt-2 cust-px-3">{card.headingText}</h6>
                                <div className="text-center font-size-14 mt-3 mb-0 cust-px-4" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.descText) }}></div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Mobile mode */}
                <div className="row justify-content-center slide2__carousel pres-carousel d-lg-none">
                    {this.props.data?.slide2Cards?.map((card, index) => (
                        <div className="d-flex align-items-center justify-content-center" key={index}>
                            <div className={"slide2__card d-flex flex-column align-items-center" + (card.isDefault ? " slide2__card--default" : "")}>
                                {card.isDefault && <div className='slide2__card--default-header'>
                                    <div className="w-100 text-center"><p><span>Default option</span> – No action or paperwork {this.getScreenWidth() > 1279 ? "required" : ""}</p></div>
                                </div>
                                }
                                <img src={card.imgSrc} alt={card.imgAlt} className={card.isDefault ? "cust-mt-2" : "cust-mt-4"} />
                                <h6 className="text-center mt-2 cust-px-2 text-grey-3">{card.headingText}</h6>
                                <div className="text-center font-size-12 mt-3 mb-0 cust-px-2 text-grey-3" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(card.descText) }}></div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row justify-content-center cta-row cust-mt-5 cust-mt-7">
                    <div className='col-0 col-sm-6'></div>
                    <div className="col-12 col-sm-6">
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-primary btn-red mb-4 btn--greytext" type="button" onClick={() => this.ctaButtonHandler()}>{this.props?.data?.slide2Cta}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Slide2;
